/*
 * Allcam – juiste reviewtelling in de Specs & Compare-tabellen.
 * De app leest de standaard Shopify-reviewvelden (reviews.rating / reviews.rating_count),
 * die verouderd zijn (max. 10). Dit script vervangt score en aantal per product door de
 * Judge.me-gegevens, via dezelfde productkaart als "Eerder door jou bekeken".
 */
(function () {
	'use strict';

	var CACHE_KEY = 'allcam_jdgm_ratings_v1';
	var cache = {};
	try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { cache = {}; }
	var pending = {};

	function saveCache() {
		try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
	}

	function root() {
		return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	}

	function handleFromHref(href) {
		var m = /\/products\/([^/?#]+)/.exec(href || '');
		return m ? decodeURIComponent(m[1]) : null;
	}

	function getRating(handle) {
		if (cache[handle]) return Promise.resolve(cache[handle]);
		if (pending[handle]) return pending[handle];
		pending[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?section_id=product-page-card')
			.then(function (r) { return r.ok ? r.text() : ''; })
			.then(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var el = doc.querySelector('.product-card-rating[data-count]');
				if (!el) return null;
				var data = {
					rating: parseFloat(el.getAttribute('data-rating')) || 0,
					count: parseInt(el.getAttribute('data-count'), 10) || 0
				};
				if (data.count > 0) {
					cache[handle] = data;
					saveCache();
				}
				return data;
			})
			.catch(function () { return null; });
		return pending[handle];
	}

	function patchBadge(badge) {
		var scope = badge.closest('.product__info') || badge.parentNode;
		var link = scope && scope.querySelector('a[href*="/products/"]');
		var handle = link && handleFromHref(link.getAttribute('href'));
		if (!handle) return;

		getRating(handle).then(function (data) {
			if (!data || !data.count) return;
			var countEl = badge.querySelector('.rating-count');
			if (countEl) {
				var text = '(' + data.count + ')';
				if (countEl.textContent.trim() !== text) countEl.textContent = text;
			}
			var stars = badge.querySelector('.rating-stars');
			if (stars) {
				var label = stars.getAttribute('aria-label') || '';
				var newLabel = label
					.replace(/^[\d.,]+/, data.rating.toFixed(1))
					.replace(/(\d+)(\s*\D*)$/, data.count + '$2');
				if (newLabel !== label) stars.setAttribute('aria-label', newLabel);
			}
		});
	}

	var HOSTS = 'sc-comparison-table, sc-dynamic-compare, sc-dynamic-compare-dialog, sc-compare-dialog, sc-product';

	function scan(shadow) {
		Array.prototype.forEach.call(shadow.querySelectorAll('.rating-badge'), patchBadge);
		// Geneste app-elementen binnen de shadow DOM
		Array.prototype.forEach.call(shadow.querySelectorAll(HOSTS), function (el) { watch(el); });
	}

	var watched = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

	function watch(host, tries) {
		if (watched && watched.has(host)) return;
		if (!host.shadowRoot) {
			// Shadow DOM nog niet aangemaakt: even later opnieuw proberen
			tries = tries || 0;
			if (tries < 20) setTimeout(function () { watch(host, tries + 1); }, 250);
			return;
		}
		if (watched) watched.add(host);
		var shadow = host.shadowRoot;
		var timer = null;
		scan(shadow);
		new MutationObserver(function () {
			clearTimeout(timer);
			timer = setTimeout(function () { scan(shadow); }, 50);
		}).observe(shadow, { childList: true, subtree: true });
	}

	function findHosts() {
		Array.prototype.forEach.call(document.querySelectorAll(HOSTS), function (el) { watch(el); });
	}

	function start() {
		findHosts();
		// De app maakt haar elementen soms later aan (bijv. de vergelijk-pop-up)
		var t = null;
		new MutationObserver(function () {
			clearTimeout(t);
			t = setTimeout(findHosts, 200);
		}).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
	else start();
})();